<div class="alert alert-info" role="alert">
    Sie haben {{ numLocations }} von {{ maxLocations }} verfügbaren {{ 'LOCATION.LOCATIONS' | translate }} angelegt.
</div>

<app-table *ngIf="tableConfig" [config]="tableConfig"/>

<app-map #mapComponent [ID]="'locations'"/>
